import React, { Component } from 'react'
import loadable from '@loadable/component'

import { webTdk, mixUrl } from 'multiPublic/index'

const Contact = loadable(() => import('../containers/Contact'))

export default class ContactPage extends Component {
    static async getInitialProps (context) {
        const { match } = context

        return {
            clientLink: mixUrl.m(match.url),
            ...webTdk
        }
    }

    render () {
        return <Contact {...this.props}/>
    }
}
